import React, { useState, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from '../components/Header/Main';
import Footer from '../components/Footer/Main';
import Home from '../components/Home/Main';
import About from '../components/About/Main';
import Contact from '../components/Contact/Main';
import Food from '../components/Menu/Main';
import Drink from '../components/Drink/Main';
import Maintenance from '../components/Maintenance/Main'

function Index() {

  const [homepage, sethomepage] = useState(false)
  const location = useLocation();
  useEffect(() => {
    sethomepage(true)
  }, [location])

  const path = location.pathname
  useEffect(() => {
    window.scroll(0, 0)
  }, [path]);

  if (process.env.REACT_APP_NEXT_PUBLIC_MAINTENANCE === 'true') {
    return <Maintenance />;
  }

  return (
    <>
      {homepage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Food />} />
        <Route path="/food" element={<Food />} />
        <Route path="/drink" element={<Drink />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  )
}

export default Index